import React, { useEffect, useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Tooltip,
    Box,
    Button,
    Typography,
    Drawer,
    Autocomplete,
    TextField,
    Stack,
    TablePagination,
} from "@mui/material";
import { ImagePaths } from "../../../Utility/ImagePaths";
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import Loader from "../../../Components/Loader";
import StoreIndentReceivePop from "./StoreIndentReceivePop";
import { CheckAccessFunc, ContentInTooltip, formatDate, GetStoreBaseUrl } from "../../../Components/CommonFunctions/CommonFunctions";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import StoreTransitDetailsPop from "./StoreTransitDetailPop";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

const active_status = [{ label: "All", value: "" }, { label: "Intiated", value: "Intiated" }, { label: "In Transit", value: "In Transit" }, { label: "Approved", value: "Approved" }]


const StoreIndentReceive = ({ loggedData, forReturn }) => {
    const history = useHistory();
    const location = useLocation();
    const [expandedRow, setExpandedRow] = useState(null);
    const [Receiveopen, setReceiveOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [TransitOpen, setTransitOpen] = useState(false);
    const [indentList, setindentList] = useState([]);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [isloader, setisloader] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);
    const [SubLocationList, setSubLocationList] = useState([]);
    const [filterData, setfilterData] = useState({
        toLocation: null,
        status: { label: "All", value: "" }
    });
    const [tblPage, setTblPage] = useState(0);
    const [tblPageSize, setTblPageSize] = useState(10);
    const EditAccess = (CheckAccessFunc((loggedData?.module_name === "store_module" ? "Store" : "Store Sub Location"), "Store", "Inbound", null, "Tab")?.editAccess)

    useEffect(() => {
        getPurchaseindentList()
        getSubLocationList()
        if (location.states?.success_message) {
            successMessage(location.states?.success_message)
            history.push({ states: { ...location?.states, success_message: "" } })
        }
    }, [])

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }

    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const handleExpandClick = (rowId) => {
        setExpandedRow(expandedRow === rowId ? null : rowId);
    };

    const getPurchaseindentList = (id) => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.STORE_STOCK_TRANSFER + `?transfer_type=${"Outbound"}${id ? `&id=${id}` : ""}&to_location=${filterData?.toLocation?.id || ""}&status=${filterData?.status?.value || ""}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setisloader(false)
                        setindentList(response.data.data || [])
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const getSubLocationList = (storeObj = null) => {
        try {
            RestAPIService.getAll(Serviceurls.SUB_LOCATION_CREATION_MASTER + '?only_store=true')
                .then((response) => {
                    if (response.data.status === 'success') {
                        setSubLocationList(response.data.data || [])
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const returnActionBtn = (row) => {
        switch (row?.status) {
            case "Initiated": return (
                <Button
                    startIcon={<TaskAltIcon />}
                    sx={{ textTransform: 'capitalize', width: "8dvw" }}
                    onClick={() => {
                        setReceiveOpen(true)
                        setSelectedRow(row)
                    }}
                    variant="contained"
                    size="small"
                >Approve</Button>)
            case "Approved": return (
                <Button
                    startIcon={<LocalShippingIcon />}
                    sx={{ textTransform: 'capitalize', width: "8dvw" }}
                    variant="contained"
                    size="small"
                    onClick={() => {
                        history.push({ pathname: `${GetStoreBaseUrl()}/IndentReceive/Add`, states: { line_items: row?.line_details, indent_data: row, for_transfer: true } })
                    }}
                >Transfer</Button>)
            case "Transferred": return (
                <Button
                    startIcon={<LocalShippingIcon />}
                    sx={{ textTransform: 'capitalize', width: "8dvw" }}
                    variant="contained"
                    size="small"
                    disabled
                    onClick={() => {
                        history.push({ pathname: `${GetStoreBaseUrl()}/IndentReceive/Add`, states: { line_items: row?.line_details, indent_data: row, for_transfer: true } })
                    }}
                >Transfer</Button>
            )
        }
    }

    const renderFilterScreen = () => {
        return (
            <Box className='eMed_rts_filter_container' >
                <Box className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>Filter</Typography>
                    <Tooltip>
                        <Button onClick={() => { setFilterOpen(false) }}>
                            <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_Canteen_CloseImg' />
                        </Button>
                    </Tooltip>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            disableClearable
                            size='small'
                            value={filterData.toLocation}
                            options={SubLocationList}
                            getOptionLabel={(option) => (typeof (option) === 'string') ? option : option?.sublocation_name}
                            onChange={(event, newValue) => {
                                setfilterData({ ...filterData, toLocation: newValue })
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={'Select From Location'}
                                />
                            )} />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            disableClearable
                            size='small'
                            value={filterData.status}
                            options={active_status}
                            getOptionLabel={(option) => (typeof (option) === 'string') ? option : option?.label}
                            onChange={(event, newValue) => {
                                setfilterData({ ...filterData, status: newValue })
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={'Status'}
                                />
                            )} />
                    </Box>
                </Box>
                <Box>
                    <Stack spacing={2} direction="row" justifyContent={'center'}>
                        <Button size='small' variant='outlined' className='eMed_Canteen_BtnText' onClick={() => {
                            setfilterData({
                                toLocation: null,
                                status: { label: "All", value: "" }
                            })
                        }}>Clear</Button>
                        <Button size='small' variant='contained' className='eMed_Canteen_BtnText' onClick={() => {
                            getPurchaseindentList()
                            setFilterOpen(false)
                        }}>Search</Button>
                    </Stack>
                </Box>
            </Box>
        )
    }


    const closeFilter = () => {
        setFilterOpen(false);
    }

    const postIndentReceive = (row, forCancel = false) => {
        try {
            // if (!productType) {
            //     errorMessage('Please Enter Product Type')
            // } else {
            let ReqLineItems = row?.line_items || []
            let CancelIds = []
            let IndentData = row?.indent_data || {}
            let LineItems = []
            ReqLineItems?.forEach((list) => {
                if (forCancel) {
                    CancelIds.push(list?.id)
                } else {
                    LineItems.push({
                        'request_quantity': +list?.request_quantity,
                        'id': list?.id || null,
                        'approved_quantity': +list?.approved_quantity || 0,
                        'transfer_quantity': 0,
                        'received_quantity': 0,
                        'batch_details': null,
                        'is_approved': true
                    })
                }
            })

            let data = {
                'indent_id': IndentData?.id || null,
                'status': forCancel ? "Cancelled" : "Approved",
                'line_cancel_ids': forCancel ? CancelIds : null,
                'indent_lines': LineItems
            }

            RestAPIService.updateWithOutId(data, Serviceurls.STORE_STOCK_TRANSFER)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setReceiveOpen(false)
                        setSelectedRow(null)
                        getPurchaseindentList()
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
            // }
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const postTransmitDetails = (row) => {
        try {

            let data = {
                'indent_id': selectedRow?.id || null,
                'mobile_number': row?.mobileNo || "",
                'contact_person': row?.contactPerson || "",
                'tracking_id': row?.trackingId || ""
            }

            RestAPIService.create(data, Serviceurls.STORE_TRANSIT_DETAILS)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setReceiveOpen(false)
                        setTransitOpen(false)
                        setSelectedRow(null)
                        getPurchaseindentList()
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
            // }
        } catch (e) {
            errorMessage(e.message)
        }
    }

    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: "flex-end", marginRight: "1vw", alignItems: 'center' }}>
                {EditAccess ? <Button size='small' sx={{ textTransform: 'capitalize' }} variant='contained' onClick={() => { history.push({ pathname: forReturn ? `${GetStoreBaseUrl()}/ReturnRequest/Add` : `${GetStoreBaseUrl()}/IndentReceive/Add`, states: { for_send_product: forReturn ? false : true, forReturn: forReturn ? true : false } }) }}>{forReturn ? "Return Request" : "Send Product"}</Button> : null}
                <IconButton onClick={() => { setFilterOpen(true) }}>
                    <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.Filter.default} alt='filter' />
                </IconButton>
            </Box>
            <Box component={Paper} display="flex" flexDirection="column" height="73dvh">
                <Box flex={1} overflow="auto"> 
                <Table stickyHeader size='small'>
                    <TableHead style={{ backgroundColor: "#f5f5f5" }}>
                        <TableRow>
                            <TableCell>Indent Date</TableCell>
                            <TableCell>Indent No</TableCell>
                            <TableCell>Request From Location</TableCell>
                            <TableCell>Request To Location</TableCell>
                            <TableCell>Transit Details</TableCell>
                            <TableCell>No Of Products</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell align="center" sx={{ width: "13dvw" }}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {indentList?.length === 0 ?
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell>
                                    <Typography sx={{ marginTop: "5vh" }}>No Records Found</Typography>
                                </TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                            : indentList
                            ?.slice(tblPage * tblPageSize, tblPage * tblPageSize + tblPageSize)
                            ?.map((row) => (
                                <React.Fragment key={row.id}>
                                    {/* Parent Row */}
                                    <TableRow>
                                        <TableCell>{row.indent_date ? formatDate(row.indent_date) : "-"}</TableCell>
                                        <TableCell>{row.indent_number ? row.indent_number : "-"}</TableCell>
                                        <TableCell>{row.from_location ? row.from_location : "-"}</TableCell>
                                        <TableCell>{row.to_location ? row.to_location : "-"}</TableCell>
                                        <TableCell>
                                            {
                                                !row.transit_person_name ?
                                                    <Box>
                                                        <Button disabled={row?.status !== "Transferred" || !EditAccess} startIcon={<AddCircleIcon />} onClick={() => {
                                                            setTransitOpen(true)
                                                            setSelectedRow(row)
                                                        }}>Add Transmit Details</Button>
                                                    </Box> :
                                                    <Box>
                                                        {row.transit_person_name ? ContentInTooltip(row.transit_person_name, 30, "0.8vw", 600) : "-"}
                                                        {row.transit_person_contact ? ContentInTooltip(row.transit_person_contact, 30, "0.8vw") : "-"}
                                                        {row.transit_tracking_id ? ContentInTooltip(row.transit_tracking_id, 30, "0.8vw") : "-"}
                                                    </Box>
                                            }
                                        </TableCell>
                                        <TableCell>{row.no_of_products ? row.no_of_products : "-"}</TableCell>
                                        <TableCell>
                                            <Box>
                                                <Typography sx={{ fontSize: "0.8vw", fontWeight: 600 }}>{row.status ? row.status : "-"}</Typography>
                                                <Typography sx={{ fontSize: "0.8vw" }}>{row.transfer_type ? row.transfer_type : "-"}</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="center" sx={{ width: "13dvw" }}>
                                            {EditAccess ? returnActionBtn(row) : null}
                                            <IconButton emed_tid={'Store_PI_grnEntry'} className='eMed_usrconf_btn' onClick={() => {
                                                history.push({ pathname: `${GetStoreBaseUrl()}/IndentRise/Add`, states: { line_items: row?.line_details, indent_data: row, for_view_only: true, return_path: `${GetStoreBaseUrl()}/IndentReceive`, viewFromOutbound: true } })
                                            }}>
                                                <img src={ImagePaths.StoreViewButton.default} alt="View" style={{ width: '1.5vw', height: '1.5vw' }} />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                </React.Fragment>
                            ))}
                    </TableBody>
                </Table>
                </Box>
                <TablePagination
                    className='eMed_tbl_pagination'
                    sx={{ border: '1px solid lightgray' }}
                    component='div'
                    rowsPerPageOptions={[10, 20, 30]}
                    count={indentList?.length || 0}
                    rowsPerPage={tblPageSize}
                    page={tblPage}
                    onPageChange={(event, newPage) => { setTblPage(newPage) }}
                    onRowsPerPageChange={(event) => { setTblPageSize(event.target.value); setTblPage(0) }}
                />
            </Box>
            {
                errorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={errorMsgText}
                        msgPop={msgClose.bind(this)
                        }
                    />
                    : null}
            {
                successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={successMsgText}
                        msgPop={msgClose.bind(this)}
                    />
                    : null
            }
            <Drawer
                anchor={'right'}
                open={filterOpen}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {isloader ? <Loader loaderOpen={isloader} /> : null}
            {(Receiveopen && selectedRow) ? <StoreIndentReceivePop open={Receiveopen} forApprove={true} Indentdata={selectedRow} handleClose={() => setReceiveOpen(false)} postIndentReceive={postIndentReceive} errorMessage={errorMessage} /> : null}
            {(TransitOpen && selectedRow) ? <StoreTransitDetailsPop open={TransitOpen} Indentdata={selectedRow} handleClose={() => setTransitOpen(false)} postTransmitDetails={postTransmitDetails} /> : null}
        </Box >

    );
};

export default StoreIndentReceive;
